import React from "react";
import MovieClip from "./clip";

const VideoPlayer: React.FC = () => {
  return (
    <div className="video__container">
      <div>
        <div className="section-title text-center"> <h2 className="section__title section__title-gradient">App previwes</h2>
        </div>
       
          <div className="video__contact">
            <MovieClip />
          </div>
         
      </div>
    </div>
  );
};

export default VideoPlayer;